import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export type PaymentData = {
  date: string;
  cabId: string;
  referenceNo?: string;
  paymentMode: string;
  amount: number;
};
interface HistoryState {
  data: PaymentData[];
  loading: boolean;
  error: string | null;
}
const initialState: any = {
  update: { updating: false, success: false },
  data: [],
  loading: false,
  error: null,
};
const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    fetchHistoryRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchHistorySuccess(state, action) {
       state.data = action.payload.data;
      state.totalPaid = action.payload.totalPaid;
      state.totalBal = action.payload.totalBal;
      state.loading = false;
    },
    fetchHistoryFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateHistoryRequest(state) {
      state.update = { updating: true, success: false };
    },
    updateHistorySuccess(state: any, action) {
      state.update = { updating: false, success: true, };
    },
    updateHistoryFailure(state, action) {
      state.update = { updating: false, success: false };
    },
    resetUpdateState(state) {
      state.update = { creating: false, success: false };
    },
  },
});
export const {
  fetchHistoryRequest,
  fetchHistorySuccess,
  fetchHistoryFailure,
  updateHistoryRequest,
  updateHistorySuccess,
  updateHistoryFailure,
  resetUpdateState,
} = historySlice.actions;
export default historySlice.reducer;
